export default __webpack_public_path__ + "static/media/07_sazenice-v-prepravkach.42483206.jpg";